import React, {useContext, useEffect, useState} from 'react';

import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

import BigText from './helpers/BigText';
import { keyListener } from './helpers/blocks';
import LoadingPage from "./helpers/LoadingPage";

import SandhiAnalysisPopUp from './errorPopUp/SandhiAnalysisPopUp';

import '../css/Components.css';
import { UserContext } from '../../providers/UserProvider';


// This function handles both sandhi and sandhi analysis type of question's parts
const LQV_Sandhi =({curQ, setQ, setCurQComplete, 
										curQ2, setQ2, setCurQComplete2, 
										curPi, type, setPartInst, btnClicked,
										setAnsSaved, partTwoBtn, allVerseQuestions}) =>{

	const [loading, setLoading] =useState(false);

	const {currentUser} =useContext(UserContext);
	
	const [questions, setQuestions] = useState([]);
	const [uans, setUans] = useState([]);
	const [analyses, setAnalyses] = useState([]);

	useEffect(() => {
		// Use allVerseQuestions if provided, otherwise fallback to curQ/curQ2
		const allQuestions = (allVerseQuestions && allVerseQuestions.length > 0) 
			? allVerseQuestions 
			: [curQ, curQ2].filter(q => q && Object.keys(q).length > 0);
		setQuestions(allQuestions);
		setUans(allQuestions.map(q => q.uans || ''));
		setAnalyses(allQuestions.map(() => ({})));
	}, [curQ, curQ2, allVerseQuestions]);

	const handleUansChange = (index, value) => {
		const newUans = [...uans];
		newUans[index] = value;
		setUans(newUans);
	};
	
	const checkAns = () => {
		const postObj = {
			method: 'POST',
			cache: 'no-cache',
			headers: {'Content-Type': 'application/json'},
			body: JSON.stringify({ pi: curPi, email:currentUser.email, curPart: curQ.parts[curPi],
									uans: uans, curQs: questions })
		}
		const getFeedback =async () => {
			setLoading(true);

			const response = await fetch(process.env.REACT_APP_FLASK_API+'check_lqv_uans', postObj);
			const data = await response.json();
			
			setAnalyses(data.analyses);
			setPartInst(data.instruction);
			setCurQComplete(data.partComplete);

			setLoading(false);
		}
		getFeedback();
	}

	//Enter = Submit
	const [btn, setBtn]=useState(null);
	useEffect(() => {
		if (btn){
			// create an eventListener
			window.addEventListener('keydown', e=>keyListener(e, btn));
			// cleanup this component
			return () => {
				window.removeEventListener('keydown', e=>keyListener(e, btn));
			};
		}
	}, [btn]);

	// To autosave when next or previous buttons are clicked
	useEffect(()=>{
		if (btnClicked===true){
			checkAns();
			setAnsSaved(true);
		};
	}, [btnClicked, checkAns, setAnsSaved]);
	
	return (
		<div>
			<LoadingPage loading={loading} />

			<div id="LQV_Sandhi">
				{questions.map((q, index) => (
					q.takeInput &&
					<div key={q.xmlid} style={{marginTop: index > 0 ? '20px' : '0px'}}>
						<span style={{fontFamily:'Shobhika'}}>
							{typeof(q.text)==='object'
							?
								<div className="d-flex align-items-center">
									<BigText sp="Q:"/>
									<div className="analysis">
										<BigText text={q.text[0]} />
										<h4>{q.text[1]}</h4>
									</div>
								</div>
							:
								<BigText sp="Q:" text={q.text}/>
							}
						</span>
						
						<div className="FlexBox">
							<BigText sp="A:" />
							<div className="AnsForm">
								{ analyses[index] && analyses[index].show && 
									<div className="analysis" style={{fontFamily:'Shobhika'}}>	
										<SandhiAnalysisPopUp 
											devaUnits={analyses[index].text.devaUnits}
											romanUnits={analyses[index].text.romanUnits}
										/>
									</div>
								}
								
								<Form>
									<Form.Control autoFocus={index === 0} as="textarea" value={uans[index]}
														placeholder="Type your answer"
														onChange={e => handleUansChange(index, e.target.value)}
														onFocus={e => {
															var val = e.target.value;
															e.target.value = '';
															e.target.value = val;
														}}
									/>
									
								</Form>
							</div>
						</div>
					</div>
				))}
			
				<div className="KeepRight" style={{width:'100%'}}>
					<Button onClick={()=>checkAns()} ref={node=>setBtn(node)}>Check All</Button>
				</div>
			</div>
		
		</div>
);};

export default LQV_Sandhi;